const timezoneJson = [
  { label: 'New York', id: 'America/New_York', name: 'America/New_York' },
  { label: 'Chicago', id: 'America/Chicago', name: 'America/Chicago' },
  { label: 'Denver', id: 'America/Denver', name: 'America/Denver' },
  { label: 'Los Angeles', id: 'America/Los_Angeles', name: 'America/Los_Angeles' }
];

export default timezoneJson;
